import AbstractPage from 'pages/AbstractPage';

export default class ContactsPage extends AbstractPage {
    constructor() {
        super();
        this.bind();
    }

    bind() {
        $('.feedback-form__submit').on('click', this.send.bind(this));
        $('.feedback-form form').on('submit', (e) => e.preventDefault());
        $('.feedback-form form [name="fz152"]').on('change', this.onFz152Toggle.bind(this));
    }

    onFz152Toggle(e) {
        $('.feedback-form__submit').prop('disabled', !$(e.currentTarget).prop('checked'));
    }

    send(e) {
        e.preventDefault();
        $('.feedback-form form [name="_protect"]').val('a2ovbz03');

        $.ajax({
            url: `/bitrix/services/main/ajax.php?c=${encodeURIComponent('nav:form')}&mode=ajax&action=submit`,
            data: $('.feedback-form form').serializeArray(),
            type: 'post',
        }).done((response) => {
            if (response.status !== 'success') {
                console.error(response.errors);

                alert(response.errors[0].message);
            }

            $('.feedback-form form').addClass('hidden');
            $('.feedback-form__success').removeClass('hidden');
            window.scrollTo(0, 0);
        }).fail((response) => {
        });
    }
}

$(function () { app.pageController = window.page = new ContactsPage(); });
